import { ISoundNotificationMessage } from '../../../interfaces/sound-notifications-message.interface';
import { IStreamData } from '../../../interfaces';
import { SoundNotificationsResponse } from 'sfx-web-contract';

export function decodeSoundNotificationsResponse(
    response: IStreamData<Uint8Array>,
): ISoundNotificationMessage {
    const { Notifications } = SoundNotificationsResponse.decode(response.payload);

    return {
        notifications: Notifications.map(notification => ({ id: notification.Id })),
    };
}
